<div class="scroll-safari-fix" style="padding-bottom: 45px">
  <div class="left-sport-menu-header">
    <mat-button-toggle-group value="{{ _dayFilter }}" (change)="changeDayFilter($event)">
      <mat-button-toggle value="300">
        {{ 'all' | translate }}
      </mat-button-toggle>
      <mat-button-toggle value="24"> 24 </mat-button-toggle>
      <mat-button-toggle value="3"> 3 </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
  <ul class="forSafari">
    <ng-container *ngFor="let item of mainData; let i = index">
      <li class="left-sport-menu-li" (click)="getCountriesBySportsID(item.SportId, i)">
        <p class="preIcon iconsCenter padding">
          <image-loader-utils url="up-arrow" extraClasses="arrow-icon down"></image-loader-utils>
        </p>
        <p class="text verticalAligner">{{ item.SportName }}</p>
        <p class="verticalAligner" *ngIf="!item.loading">
          <mat-chip-list>
            <mat-chip>{{ item.SportEventCount }}</mat-chip>
          </mat-chip-list>
        </p>
        <p class="verticalAligner">
          <mat-spinner [diameter]="25" *ngIf="item.loading"></mat-spinner>
        </p>
      </li>

      <ul class="left-sport-menu-level1" [ngClass]="{ ulState: item.state }">
        <ng-container *ngFor="let item2 of mainData[i].level; let k = index">
          <li class="left-sport-menu-li" (click)="getTourementsByCountryID(item.SportId, item2.CategoryId, i, k)">
            <p class="preIcon iconsCenter padding">
              <image-loader-utils url="up-arrow" extraClasses="arrow-icon down"></image-loader-utils>
            </p>
            <image-loader-flag-utils [url]="item2.IsoName" [isFlags]="true" extraClasses="flag-rounded"></image-loader-flag-utils>
            <p class="text verticalAligner">{{ item2.CategoryName }}</p>
          </li>
          <ul class="left-sport-menu-level2" [ngClass]="{ ulState: item2.state }">
            <li>
              <p class="preIcon iconsCenter padding">
                <mat-checkbox color="primary" [value]="false" [(ngModel)]="item2.allselected" (change)="selectAll(mainData[i].level[k], $event, item)">{{
                  'all' | t
                }}</mat-checkbox>
              </p>
            </li>
            <ng-container *ngFor="let item3 of mainData[i].level[k].level; let l = index">
              <li>
                <p class="preIcon iconsCenter padding">
                  <mat-checkbox
                    [name]="'ch_' + item3.CategoryId"
                    color="primary"
                    [value]="{
                      TournamentName: item3.TournamentName,
                      TournamentId: item3.TournamentId,
                      CategoryId: item3.CategoryId,
                      CategoryName: item2.CategoryName,
                      SportId: item.SportId,
                      SportName: item.SportName
                    }"
                    (change)="selectedLeague($event, item2)"
                    [(ngModel)]="mainData[i].level[k].level[l].checked"
                    >{{ item3.TournamentName }}</mat-checkbox
                  >
                </p>
              </li>
            </ng-container>
          </ul>
        </ng-container>
      </ul>
    </ng-container>
  </ul>
</div>
<div class="left-sport-menu-back" matRipple (click)="backButton()">
  <span class="icon"> <image-loader-utils url="up-arrow" extraClasses="arrow-icon right"></image-loader-utils></span>
  <span class="text">{{ 'close_menu' | translate }}</span>
</div>
